module.exports = __webpack_public_path__ + "img/a496ca939d94b2ad8b0ec7573b80aa7c.jpg";